import { setupWorker } from 'msw/browser';

import { handlers } from './handlers';

// This configures a Service Worker with the given request handlers.
export const worker = setupWorker(...handlers);

// re-export so we can dynamically import in cypress tests
export * from '__generated__';
